"use strict";

import Vue from 'vue';
import axios from "axios";
import router from "@/router";
import {Loading, Message, MessageBox} from "element-ui";
import {getToken, removeToken} from "@/utils/auth";

let loading;
let loadingNum = 0;  //内存中正在请求的数量

let proxyPrefix = '/buding-api';
let ErrorCode = {
    SUCCESS: '200',
    UNAUTHORIZED: '401',
    EXCEPTION: '500'
};
let lastResponseCode = 'lastResponseCode';

// 打开加载动画
function startLoading() {
    if (loadingNum === 0) {
        loading = Loading.service({
            lock: true,
            text: '拼命加载中...',
            background: 'rgba(255,255,255,0.1)',
            target: document.querySelector('.content')
        })
    }
    loadingNum++;
}

// 关闭加载动画
function endLoading() {
    loadingNum--;
    if (loadingNum <= 0) {
        loading.close();
        loadingNum = 0;
    }
}

let config = {};
const _axios = axios.create(config);

// 请求拦截
_axios.interceptors.request.use(function (config) {
        let configUrl = config.url;
        // 打开加载动画
        if (!('skipLoading' in config.headers)) {
            startLoading();
        }
        // 让每个请求携带token
        config.headers['Authorization'] = getToken();
        config.url = proxyPrefix + configUrl;
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

// 响应拦截
_axios.interceptors.response.use(function (response) {
        // 关闭加载动画    
        if (!('skipLoading' in response.config.headers)) {
            endLoading();
        }
        const code = response.data.code;
        const msg = response.data.msg;
        const lastCode = sessionStorage.getItem(lastResponseCode) || '';
        sessionStorage.setItem(lastResponseCode, code);
        switch (code) {
            // 请求成功
            case ErrorCode.SUCCESS : {
                return response;
            }
            // 登录过期，认证失败
            case ErrorCode.UNAUTHORIZED : {
                // 防止多次请求多次弹窗
                if (lastCode !== code) {
                    // MessageBox.confirm('登录已过期, 是否重新登录?', '提示', {
                    //     confirmButtonText: '重新登录',
                    //     cancelButtonText: '停在此页',
                    //     type: 'warning'
                    // }).then(() => {
                        // 清除token
                        removeToken();
                        // 清除Home页面登录用户信息
                        sessionStorage.setItem('loginUser', '{}');
                        Vue.prototype.$eventBus.$emit('userLogin', {});
                        // 跳转到登录页
                        router.replace({
                            path: '/login',
                            query: {redirect: router.currentRoute.fullPath}
                        }).then();
                    // });
                }
                return Promise.reject(new Error(msg));
            }
            // 请求失败
            case ErrorCode.EXCEPTION : {
                Message({
                    message: msg,
                    type: 'error',
                    duration: 1000
                })
                return Promise.reject(new Error(msg));
            }
            // 其他未知情况
            default : {
                // 调用了Excel导出接口，无状态码，返回的是字节码
                // 或者axios获取项目内json文件，无状态码，返回的是json字符串
                if (response.request.responseURL.search("export") > 0
                    || response.request.responseURL.search("online") > 0) {
                    return response;
                } else {
                    let errMsg = '未知异常';
                    Message({
                        message: errMsg,
                        type: 'error',
                        duration: 1000
                    })
                    return Promise.reject(new Error(errMsg));
                }
            }
        }
    },
    function (error) {
        endLoading();  //关闭加载动画
        Message({
            message: error.response.data.message || '接口异常',
            type: 'error',
            duration: 3000
        })
        return Promise.reject(error);
    }
);

const axiosPlugin = {
    install(Vue) {
        Vue.axios = _axios;
        window.axios = _axios;
        Object.defineProperties(Vue.prototype, {
            axios: {
                get() {
                    return _axios;
                }
            }
        })
    }
};

Vue.use(axiosPlugin);

export default axiosPlugin;
